import {TierInfo} from '@eCommerce/frontend-legacy-shared-library-native';
import {createSelector} from '@reduxjs/toolkit';

import {AppState} from '../';
import {ContentState} from '../content';

export const contentSelector = (state: AppState): ContentState => state.content;

export const navigationContentSelector = createSelector(
  contentSelector,
  content => content.navigation
);

export const empireFooterContentSelector = createSelector(
  contentSelector,
  content => content.empireFooter.empireFooterContent
);

export const empireFooterContentTimeStampSelector = createSelector(
  contentSelector,
  content => content.empireFooter.empireFooterContentTimestamp
);

export const navigationLogoSelector = createSelector(
  navigationContentSelector,
  navContent => navContent?.logo ?? ''
);

export const navigationLinksSelector = createSelector(
  navigationContentSelector,
  navContent => navContent?.links ?? []
);

export const isWebViewSelector = createSelector(
  contentSelector,
  content => content.isHeaderFooterSuppressed
);
